import { render, staticRenderFns } from "./BrokenImagesNotice.vue?vue&type=template&id=38c862aa&scoped=true&"
import script from "./BrokenImagesNotice.vue?vue&type=script&lang=ts&"
export * from "./BrokenImagesNotice.vue?vue&type=script&lang=ts&"
import style0 from "./BrokenImagesNotice.vue?vue&type=style&index=0&id=38c862aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c862aa",
  null
  
)

export default component.exports